import * as React from 'react'
import {CHAINTYPES, ROLES, storeType, userFilterType,} from "../../reducers/types";
import FormControl from '@material-ui/core/FormControl';
import {MyInput, Label} from "../../components/CustomUIComp/CustomFormElem";
import {injectIntl, IntlShape} from 'react-intl'
interface IProps {
    storeList?: storeType[],
    userFilter: userFilterType,
    handleFilterChange: (value: any) => void,
    onConfirm: () => void,
    onClearFilter:()=> void,
    onAddUser: () => void,
    role: ROLES,
    chainType: CHAINTYPES,
    intl: IntlShape
}

interface IState {
}

class UserFilters extends React.Component<IProps, IState> {
    handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        this.props.handleFilterChange(event.target)
    }

    public render() {
        let {intl} = this.props
        return (
            <div className="userFilters">
                <div className="line">
                        <FormControl className="formControl">
                            <Label shrink htmlFor="bootstrap-input">
                                {intl.formatMessage({id: 'name'})}
                            </Label>
                            <MyInput value={this.props.userFilter.name} onChange={this.handleChange} name="name"/>
                        </FormControl>

                    <FormControl className="formControl">
                        <Label shrink htmlFor="bootstrap-input">
                            {intl.formatMessage({id: 'loginNo'})}
                        </Label>
                        <MyInput value={this.props.userFilter.loginNo} onChange={this.handleChange} name="loginNo"/>
                    </FormControl>
                </div>
                <div className="buttons">
                    <button className="primaryButton" onClick={this.props.onConfirm}>{intl.formatMessage({id: 'query'})}</button>
                    <button className="whiteButton" onClick={this.props.onClearFilter}>{intl.formatMessage({id: 'clear'})}</button>
                    <button className="whiteButton" onClick={this.props.onAddUser}>{intl.formatMessage({id: 'newUser'})}</button>
                </div>
            </div>
        );
    }
}

export default injectIntl(UserFilters)
